import { Breadcrumb } from 'antd'
import AboutTabs from './AboutTabs'
import { useState } from 'react'

const About: React.FC = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
     <div>
      <div className="mb-6">
        <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">About Us</h1>
        <div className="mb-4">
          <Breadcrumb separator=">" items={[{ title: "About Us" },{title:breadcrumb}]} />
        </div>
        <AboutTabs setBreadcrumb={setBreadcrumb} />
      </div>
    </div>
  )
}

export default About